import React from 'react';

const ActressStats = ({ stats, className = "" }) => {
  if (!stats) {
    return null;
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown';
    const date = new Date(dateString);
    return date.toLocaleDateString('ja-JP');
  };

  const formatDuration = (days) => {
    if (!days) return 'Unknown';
    const years = Math.floor(days / 365);
    const months = Math.floor((days % 365) / 30);
    
    if (years > 0) {
      return `${years}年${months > 0 ? `${months}ヶ月` : ''}`;
    }
    return `${months}ヶ月`;
  };

  return (
    <div className={`bg-white rounded-lg shadow-md p-6 ${className}`}>
      <h3 className="text-xl font-bold mb-4">活動統計</h3>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-blue-600">{stats.total_videos || 0}</div>
          <div className="text-sm text-gray-600">総作品数</div>
        </div>
        
        <div className="text-center">
          <div className="text-2xl font-bold text-green-600">{stats.careerYears || 0}</div>
          <div className="text-sm text-gray-600">活動年数</div>
        </div>
        
        <div className="text-center">
          <div className="text-2xl font-bold text-purple-600">{stats.popularity_score || 0}</div>
          <div className="text-sm text-gray-600">人気スコア</div>
        </div>
        
        <div className="text-center">
          <div className="text-2xl font-bold text-red-600">{stats.favorite_count || 0}</div>
          <div className="text-sm text-gray-600">お気に入り</div>
        </div>
      </div>
      
      {(stats.debut_date || stats.last_video_date) && (
        <div className="mt-6 pt-4 border-t">
          <h4 className="font-semibold mb-3">活動期間</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {stats.debut_date && (
              <div>
                <span className="text-sm text-gray-600">デビュー日:</span>
                <div className="font-medium">{formatDate(stats.debut_date)}</div>
              </div>
            )}
            {stats.last_video_date && (
              <div>
                <span className="text-sm text-gray-600">最新作品:</span>
                <div className="font-medium">{formatDate(stats.last_video_date)}</div>
              </div>
            )}
          </div>
          
          {stats.career_duration_days && (
            <div className="mt-3">
              <span className="text-sm text-gray-600">活動期間:</span>
              <div className="font-medium">{formatDuration(stats.career_duration_days)}</div>
            </div>
          )}
        </div>
      )}
      
      {stats.last_calculated_at && (
        <div className="mt-4 text-xs text-gray-500">
          最終更新: {formatDate(stats.last_calculated_at)}
        </div>
      )}
    </div>
  );
};

export default ActressStats;